import { Button } from "primereact/button";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PriceBlock from "./PriceBlock";
import Image from "./Image";
import { useBasket } from "../context/BasketContext";
import { encodeArticleForUrl } from "../helpers/helpers";

function ProductLuxury({ item }) {
    const navigate = useNavigate();
    const { addToBasket, isInBasket } = useBasket();
    const [isAdded, setIsAdded] = useState(false);

    const inBasket = isInBasket(item?.article);

    const handleProductClick = () => {
        if (item?.article) {
            // Use collection from item if available for optimized fetch
            const collectionPath = item.collection?.toLowerCase() || '';
            const encodedArticle = encodeArticleForUrl(item.article);
            navigate(collectionPath ? `/catalog/${collectionPath}/${encodedArticle}` : `/catalog/${encodedArticle}`);
        }
    };

    const handleButtonClick = (e) => {
        e.stopPropagation();
        if (inBasket) {
            navigate("/basket");
        } else {
            addToBasket(item);
            setIsAdded(true);
            setTimeout(() => setIsAdded(false), 1500);
        }
    };

    // Generate descriptive alt text
    const altText = item.imageAlt || `${item.name || 'Ювелірний виріб'} - ${item.productType || 'прикраса'} ${item.materialType ? `з ${item.materialType}` : ''} від TSATSKY`;

    return (
        <article className="grid mt-11 min-w-[300px] relative" itemScope itemType="https://schema.org/Product">
            <div
                className="cursor-pointer"
                onClick={handleProductClick}
                title={`Переглянути ${item.name || 'товар'}`}
            >
                <Image
                    highQualitySrc={item.image}
                    alt={altText}
                    itemProp="image"
                />
            </div>

            <div className="flex items-center justify-between mt-2">
                <PriceBlock
                    priceStyles="text-[#A3A1A5] text-xl"
                    price={item.price}
                    oldPrice={item.oldPrice}
                />

                <Button
                    label={isAdded ? "Додано!" : inBasket ? "У кошику" : "В кошик"}
                    icon={isAdded ? "pi pi-check" : inBasket ? "pi pi-shopping-bag" : "pi pi-shopping-cart"}
                    onClick={handleButtonClick}
                    disabled={isAdded}
                    className={`font-semibold rounded-none shadow-none py-3 lg:py-4 px-5 lg:px-6 border w-fit transition-all duration-300 transform
                        ${isAdded
                            ? "border-green-500 bg-green-500 text-white scale-105"
                            : inBasket
                            ? "border-black bg-white text-black hover:scale-105 active:scale-95"
                            : "border-[#A7A7A4] hover:border-black hover:bg-white hover:text-black text-[#A7A7A4] hover:scale-105 active:scale-95"
                        }`}
                />
            </div>
        </article>
    );
}

export default ProductLuxury;
